import {EntityModel} from "@fedeltapointofsale/data-client";
import {AccountInvoiceData} from "./account-invoice.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class AccountInvoiceEntityModel extends EntityModel<AccountInvoiceData> {
    constructor(injector: Injector) {
        super(injector, AccountInvoiceData)
    }
}
